import React from 'react'
import { StepForm } from '../StepForm'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { NumberSelectForm } from 'spa/member/components/NumberSelectForm'
import { KarteInputForm } from 'spa/member/components/KarteInputForm'
import { RadioForm } from 'spa/member/components/RadioForm'
import { TextAreaForm } from 'spa/member/components/TextAreaForm'
import { FormType } from '../types'

type Props = {
  formType: FormType
}

const StyledFormOuter = styled.div`
  > *:not(:last-child) {
    margin-bottom: 32px;
  }
`

export const StyledSecondForm: React.FC<Props> = (props) => {
  const { setValue } = useFormContext()

  const booleanOptions = [
    { label: '希望する', value: 'true' },
    { label: '希望しない', value: 'false' },
  ]

  return (
    <StepForm formType={props.formType} title="案件のご条件">
      <StyledFormOuter>
        <NumberSelectForm
          name='desired_monthly_salary'
          label='希望報酬額 （1.0人月換算/税別）'
          annotationNote='※1.0人月=月160時間に換算した金額'
          start={200000}
          step={10000}
          end={2000000}
          placeholder='選択してください'
          required
          rules={{
            required: 'この質問は必須です'
          }}
          onChange={(e) => {
            const desiredHourlySalary = Math.ceil(Number(e.target.value) / 160)
            setValue('_desired_hourly_salary', desiredHourlySalary.toLocaleString())
          }}
          dataCy="desired-monthly-salary"
        />
        <KarteInputForm
          name='_desired_hourly_salary'
          label='希望報酬額（時給換算/税別）'
          noBadge={true}
          required
          inputProps={{
            disabled: true,
          }}
          dataCy="desired-hourly-salary"
        />
        <TextAreaForm
          name='additional_conditions'
          label='希望条件への補足があれば教えてください'
          annotationNote='※金額、業務内容、稼働時間帯、など'
          rules={{
            maxLength: {
              value: 1000,
              message: '1000文字以内で入力してください'
            }
          }}
          dataCy="additional-conditions"
        />
        <RadioForm
          name='full_time_job_introduction'
          label='正社員案件のご紹介について'
          options={booleanOptions}
          required
          rules={{
            required: 'この質問は必須です'
          }}
          dataCy="full-time-job-introduction"
        />
        <RadioForm
          name='temp_job_introduction'
          label='派遣案件のご紹介について'
          options={booleanOptions}
          required
          rules={{
            required: 'この質問は必須です'
          }}
          dataCy="temp-job-introduction"
        />
        <TextAreaForm
          name='pre_communication_notes'
          label='ご参画前に稼働先へお伝えしておいた方がよいことがございましたら教えてください'
          rules={{
            maxLength: {
              value: 1000,
              message: '1000文字以内で入力してください'
            }
          }}
          dataCy="pre-communication-notes"
        />
      </StyledFormOuter>
    </StepForm>
  )
}

